import type { HomeSlice } from '../bs/home'

/**
 * Serbian overrides for the home screens.
 *
 * The jat reflex throughout: *prijedlog* → *predlog*, *bezbjednost* →
 * *bezbednost*, *posljednje* → *poslednje*, *riješeno* → *rešeno*, *ocjena* →
 * *ocena*, *mjesec* → *mesec*, *zahtijeva* → *zahteva*, *dodijeljeno* →
 * *dodeljeno*, *izmjena* → *izmena*, *ovdje* → *ovde*, *pojaviće* stays.
 */
export const home: Partial<HomeSlice> = {
  'home.report.title': 'Prijavi kvar ili predlog',
  'home.report.text': 'Kvar, incident, bezbednost ili predlog za poboljšanje',

  'home.stat.mySubmissions.explain': 'Vaše prijave iz poslednjih dvanaest meseci.',
  'home.stat.inProgress.explain':
    'Vaše prijave koje još nisu rešene, bez obzira na to kada ste ih poslali.',
  'home.stat.acceptedProposals': 'Prihvaćeni predlozi',
  'home.stat.acceptedProposals.explain':
    'Predlozi koje je komisija prihvatila — jedino oni podižu vašu ocenu na rang listi, a odbijen predlog ne oduzima ništa.',
  'home.stat.points.explain':
    'Poeni koje je komisija dala vašim prihvaćenim predlozima; u ocenu na rang listi ulazi broj prihvaćenih, a ne poeni.',

  'home.recent.title': 'Moje poslednje prijave',
  'home.recent.emptyText': 'Kada prijavite kvar ili pošaljete predlog, pojaviće se ovde.',

  'home.stat.openSubmissions.hint': 'Sve što još nije rešeno',
  'home.stat.overdue.needsAttention': 'Zahteva pažnju danas',
  'home.stat.overdue.explain':
    'Otvorene prijave kojima je rok prošao; prijave bez upisanog roka se ovde ne broje.',
  'home.stat.myTasks.explain': 'Zadaci dodeljeni vama koji još nisu završeni.',
  'home.stat.fiveSThisMonth': '5S ovog meseca',
  'home.stat.fiveS.hint': 'Ocena radnih centara',
  'home.stat.fiveS.notAllowed': 'Nemate pravo ocenjivanja',

  'home.module.queue.text': 'Nerešene prijave po prioritetu',
  'home.module.tasks.text': 'Šta je dodeljeno vama i vašem timu',
  'home.module.fiveS.text': 'Ocena radnog centra po kriterijumima',
  'home.module.admin.text': 'Korisnici, šifarnici i dnevnik izmena',

  'home.queue.emptyText': 'Sve prijave su rešene ili zatvorene.',
  // *prosjek* -> *prosek*.
  'home.fiveS.plant': 'Prosek pogona',
  // *nigdje* -> *nigde*, and *na kom* where Bosnian writes *na kojem*.
  'home.fiveS.explain':
    'Prosek pogona pored stoji samo da imate s čim uporediti svoj broj — to nije rang i nigde ne piše na kom ste mestu.',

  // *ocjena* -> *ocena*, *prijedlog* -> *predlog*, *mjesto* -> *mesto*,
  // *završeni* is shared.
  'leaderboard.formula':
    'Osnova: 5S {fiveS} i završeni zadaci {tasks}. Prihvaćeni predlozi dodaju do +{bonus} bodova ({accepted} prihvaćena predloga za punu premiju) — predlozi mogu samo da podignu ocenu, nikada je ne smanjuju.',
  // *dio* -> *deo*, *dijeli* -> *deli*, *sljedeći* -> *sledeći*.
  'leaderboard.explain.note':
    'Deo za 5S govori o mašinama koje je neko održavao, a ne o njemu — ko je prešao na zapušten centar ima nizak procenat upravo zbog toga. Prihvaćeni predlozi se dodaju na osnovu i mogu je samo podići: odbijen predlog ne oduzima ništa. Ko nije bio ni na jednom obilasku ili nema nijedan zadatak, ocenjuje se samo po onome što ima, a deo koji nedostaje se ne računa kao nula.',
  'leaderboard.explain.ties':
    'Isti rezultat deli isto mesto: dvoje sa 82 su oboje drugi, a sledeći je četvrti.',
  'leaderboard.rating': 'Ocena',
  'leaderboard.position': 'Mesto',
}
